import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=48e735b6&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=ts"
export * from "./Documents.vue?vue&type=script&lang=ts"
import style0 from "./Documents.vue?vue&type=style&index=0&id=48e735b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e735b6",
  null
  
)

export default component.exports